<template>
    <div class="m-portlet m-portlet--mobile m-portlet--body-progress-">
        <div class="m-portlet__body">
            <div class="m-portlet__body-progress">{{ labels.title_images }}</div>
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="photo in photos" v-show="photos.length">
                        <img class="img-thumb" :src="photo" alt="" width="auto">
                    </div>
                    <div class="swiper-slide" id="toto" v-show="!photos.length">
                        <img class="img-thumb" :src="placeholder" alt="" width="auto">
                    </div>
                </div>
                <!-- Add Pagination -->
                <div class="swiper-pagination" v-show="photos.length"></div>
                <!-- Add Arrows -->
                <div class="swiper-button-prev" v-show="photos.length > 1"><i class="fa fa-chevron-left"></i></div>
                <div class="swiper-button-next" v-show="photos.length > 1"><i class="fa fa-chevron-right"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const placeholder = require('../../../assets/img/placeholder-product.jpg')

export default {
    name: 'Images',
    props: ['previewProduct'],
    data () {
        return {
            photos: [],
            placeholder: placeholder
        }
    },
    computed: {
        ...mapState({
            labels: state => state.labels
        })
    },
    created () {
        this.photos = this.previewProduct.photos || []
        this.previewProduct.mainPhoto ? this.photos.unshift(this.previewProduct.mainPhoto) : null
    },
    mounted () {
        this.$nextTick(function () {
            var mySwiper = new Swiper('.swiper-container', {
                speed: 400,
                spaceBetween: 100,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            })
        })
    }
}
</script>

<style scoped>
    @import "https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.5.0/css/swiper.css";
    @import "https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.5.0/css/swiper.min.css";

    .swiper-wrapper {
        width: 100%;
        height: 400px;
    }
    .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;
        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }
    .swiper-pagination-bullet {
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        font-size: 12px;
        color: #000;
        opacity: 1;
        background: rgba(0,0,0,0.2);
    }
    .swiper-pagination-bullet-active {
        color:#fff;
        background: #007aff;
    }
    .img-thumb {
        max-height: 300px;
        max-width: 250px;
    }
    .swiper-button-next {
        right: -18px;
        background-image: url();
    }
    .swiper-button-prev {
        background-image: url();
    }
</style>



// WEBPACK FOOTER //
// src/components/Products/Preview/Images.vue